/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { InfectedDataClassificationSize } from '../models/InfectedDataClassificationSize';

export class InfectedDataByClassification {
  /**
  * Infected data per data class
  */
  'infectedDataClasses': Array<InfectedDataClassificationSize>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "infectedDataClasses",
      "baseName": "infectedDataClasses",
      "type": "Array<InfectedDataClassificationSize>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return InfectedDataByClassification.attributeTypeMap;
  }

  public constructor() {
  }
}

